// takes a product and returns true if any of the variants have the
// company_owned_dealer_variant metafield set to true
// this functionality is currently only used in Invisible Fence

function hasCompanyOwnedDealerVariants(product) {
  if (!product) return false;

  return product.variants?.some(variant => {
    const metafield = variant.metafields?.find(
      variantMetafield =>
        variantMetafield.key === 'company_owned_dealer_variant'
    );
    return metafield && metafield.value === 'true';
  });
}

export default hasCompanyOwnedDealerVariants;
